<template>
  <div>
    <v-btn
      color="primary"
      @click="onSubmit"
      :loading="loading"
      :disabled="cerrada"
    >
      <v-icon left>mdi-printer</v-icon>
      Imprimir
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { printReceiptPDF } from './pdf_recibo.js';
import FormatDecimalMixin from '@/mixins/FormatDecimal';
import PrecioMixin from '@/mixins/Precios';

export default {
  name: 'ResumenPrintComponent',
  mixins: [FormatDecimalMixin, PrecioMixin],
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
    }
  },
  beforeMount () {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  computed: {
    ...mapGetters('Transacciones', ['edited']),
    ...mapGetters('Cuentas', ['cerrada']),
    cuenta () {
      return this.$store.getters['Cuentas/selected']
    },
    cuentaSelected () {
      return this.cuenta && this.cuenta.id > 0;
    },
  },
  methods: {
    async onSubmit () {
      try {
        this.loading = true;
        const transaccion = this.item || this.edited;
        printReceiptPDF(transaccion, this.cuenta);
      } catch (error) {
        console.error('Error al generar el PDF:', error);
        alert('Hubo un problema al generar el ticket de impresión.');
      } finally {
        this.loading = false;
      }
    },
    handleKeyboard (event) {
      const actions = {
        F4: this.onSubmit,
      };

      if (!event.ctrlKey && this.cuentaSelected && actions[event.key]) {
        event.preventDefault()
        actions[event.key].call(this, event);
      }
      else if (!event.ctrlKey && !this.cuentaSelected && actions[event.key]) {
        event.preventDefault()
        alert('Primero debe seleccionar una cuenta y un periodo!')
      }
    },
  },

}
</script>
